import React, { useState, useContext } from "react";
import axios from "axios";
import { useHistory, Link } from "react-router-dom";
import AuthContext from "../../auth/auth-context";
import { obtainToken } from "../../api/auth.api";
import PropTypes from "prop-types";
import Button from "react-bootstrap/Button";
import Loader from "../../components/loader/loader";
import CALogo from "../../assets/CA_logo.png";
import { isNotEmpty } from "../../utils/inputValidationRules";
import useInputState from "../../hooks/useInputState";

function ResetPassword() {

    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [emailValue, setEmailValue] = useState("");

    const handleSubmit = async (event) => {
        event.preventDefault();
        console.log("Form submitted");
        setErrorMessage("");
        setSuccessMessage("");
        if(!isNotEmpty(emailValue)) {
            setErrorMessage("Email is required");
            return;
        }

        try {

            setIsLoading(true);

            const resetPasswordRes = await axios.post(`${process.env.REACT_APP_SERVER_URL}/auth/password/reset/`, {email: emailValue})
            console.log("Reset Password Response:", resetPasswordRes.data);
            if(resetPasswordRes.data.sent_to) {
                setSuccessMessage(`${resetPasswordRes.data.detail}`);
            }
        } catch(error) {
            setIsLoading(false);
            console.error("Error during form submission:", error);
            setErrorMessage("An error occurred while processing your request.");

        }
    }



  return (
    <div id="page" className="login">
      <div className="frm">
      {successMessage === "" && (
        <form className="formCard" onSubmit={handleSubmit}>
            <img src={CALogo} alt="CA_Logo" className="mb-3" />
            <div className="row mb-3">
            <div className={`col-12 cams-form-control`}>
                <div className="p-2">Please enter your email to reset your password.</div>
                <label htmlFor="username">Email</label>
                <input
                type="text"
                id="email" // Add an ID for accessibility
                value={emailValue}
                onChange={() => setEmailValue(event.target.value)}
                //   onBlur={usernameBlurHandler}
                />
            </div>
            </div>
            {errorMessage === "" ? null : (
            <div className="messageDisplay">
                <span className="errMsg">{errorMessage}</span>
            </div>
            )}
            
            {/* Change the button type to "submit" */}
            <Button disabled={isLoading} type="submit">
            Reset
            </Button>
            <br />
        </form>
      )}
        
        {successMessage === "" ? null : (
            <div className="formCard">
                <div className="messageDisplay">
                    <div className="successMsg">{successMessage}</div>
                    <div>
                        <Link to="/" className="forgot-password-link">
                            Go to Login
                        </Link>
                    </div>
                </div>
            </div>
            )}
      </div>
    </div>
  )
}

export default ResetPassword